import API from './api';

export const employeeService = {
  // Get all employees
  getEmployees: (params) => API.get('/employees', { params }),

  // Get employees for dropdown (no admin/HR restriction)
  getEmployeesForDropdown: () => API.get('/employees/fortask'),

  // Get my team (Manager's only)
  getMyTeam: () => API.get('/employees/my-team'),

  // Get single employee
  getEmployeeById: (id) => API.get(`/employees/${id}`),

  // Get current user profile
  getCurrentUserProfile: (userId) => API.get(`/employees/me/${userId}`),

  // Update current user profile
  updateCurrentUserProfile: (userId, data) => API.put(`/employees/me/${userId}`, data),

  // Create new employee
  createEmployee: (data) => API.post('/employees', data),

  // Update employee
  updateEmployee: (id, data) => API.put(`/employees/${id}`, data),

  // Deactivate employee
  deactivateEmployee: (id) => API.delete(`/employees/${id}`),

  // Get employee statistics
  getEmployeeStats: () => API.get('/employees/stats/summary'),
};
